var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFicha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.78 26H1.71997L6.21997 8H32.28L27.78 26ZM4.28003 24H26.22L29.72 10H7.78003L4.28003 24Z",
    fill: "#1680E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H25V4H15L12.71 0H0V23.86L3.47 10L4 6Z",
    fill: "#053779"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFicha);
export default __webpack_public_path__ + "static/media/ficha.bf3a4bc7c4ea9dc28f014d719c96c6e1.svg";
export { ForwardRef as ReactComponent };